module.exports = __webpack_public_path__ + "static/media/background.267eafeb.png";